import { authRoles } from 'app/auth';
import FeltoltesAdatlapTable from 'app/admin/feltoltesadatlap/table/FeltoltesAdatlapTable';
import FeltoltesAdatlapEditForm from 'app/admin/feltoltesadatlap/editform/FeltoltesAdatlapSubmitForm';

export default [
	{
		path: '/feltoltesadatlap/edit/:id',
		component: FeltoltesAdatlapEditForm,
		auth: authRoles.vizsgaztato
	},
	{
		path: '/feltoltesadatlap/:sessionNameParam?',
		component: FeltoltesAdatlapTable,
		auth: authRoles.vizsgaztato
	}
];
